import React, { useState, useEffect } from 'react';
import { Pie } from '@ant-design/plots';
import { AnonymousUserLocationService } from "deliziora-client-module/client-web";

const PieChartAdmin = () => {
  const [districtData, setDistrictData] = useState([]);
  const [mostVisitedDistrict, setMostVisitedDistrict] = useState(null);

  useEffect(() => {
    // Recuperar o valor salvo do distrito mais visitado do Local Storage
    const storedDistrict = localStorage.getItem('mostVisitedDistrict');
    if (storedDistrict) {
      setMostVisitedDistrict(storedDistrict);
    }
  }, []);

  useEffect(() => {
    AnonymousUserLocationService.returnAllUsersLocation()
      .then((res) => {
        const districtCount = {};
        res.data.forEach((entry) => {
          const district = entry.district;
          districtCount[district] = (districtCount[district] || 0) + 1;
        });

        // Convert districtCount object to the desired format
        const transformedData = Object.entries(districtCount).map(
          ([type, value]) => ({
            type,
            value,
          })
        );

        // Encontrar o distrito mais visitado
        let mostVisited = null;
        let maxVisits = 0;
        transformedData.forEach((district) => {
          if (district.value > maxVisits) {
            mostVisited = district.type;
            maxVisits = district.value;
          }
        });

        // Salvar o distrito mais visitado no Local Storage
        localStorage.setItem('mostVisitedDistrict', mostVisited);

        // Atualizar o estado do distrito mais visitado
        setMostVisitedDistrict(mostVisited);

        // Atualizar o estado dos dados do distrito
        setDistrictData(transformedData);
      })
      .catch((err) => console.error(err));

    return () => { };
  }, []);

  const config = {
    appendPadding: 10,
    data: districtData,
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    theme: {
      colors10: [
        '#ff9900',
        '#ffc600',
        '#ffd700',
        '#f4ff00',
        '#ffb300',
        '#ff3e00',
        '#ff7800',
        '#ff9b00',
      ],
    },
    label: {
      type: 'outher',
      content: '{name} {percentage}',
    },
    interactions: [
      {
        type: 'pie-legend-active',
      },
      {
        type: 'element-active',
      },
    ],
  };

  return <Pie {...config} />;
};

export default PieChartAdmin;
